import IHomeDelivery from '../../interfaces/homeDelivery/homeDelivery';

export const getHomeDeliveryDataModel = (data: IHomeDelivery, staffEmail: string) => {
	const model = {
		trackingnumber: data.trackingnumber,
		customerEmail: data.customerEmail,
		staffEmail: staffEmail,
		phone: data.phone,
		name: data.name,
		address: data.address,
		zip: data.zip,
	};

	return model;
};
